import React, { Component } from 'react';
import CoFollowTable from './CoFollowTable';
import FundsFollowTable from './FundsFollowTable';
import ProjectSideNav from '../../projectContract/SideNav';
import SideNav from '../SideNav';

class CoFollowFunds extends Component {
    state = {
        cur: 'co',
        tabs:[
            { lable:'CO跟踪表', key: 'co' },
            { lable:'请款预计跟踪表', key: 'funds' }
        ]
    }

    handleBtnClick = (cur) => {
        this.setState({ cur });
    }

    render() {
        const { cur, tabs } = this.state;
        const hash = location.hash.slice(1);
        return (
            <div className="content">
               {
                    hash === '/contractManagement/coFollowFunds' ?
                        <SideNav selectKey='coFollowFunds' />
                    :
                        <ProjectSideNav selectKey='coFollowFunds' />
                }
                <div className="main">
                    <div className="main-content">
                        <div className="tab_flex">
                            <a onClick={() => this.handleBtnClick('co')} className={cur == 'co' ? 'curr' : ''} >
                                CO跟踪表
                            </a>
                            <a onClick={() => this.handleBtnClick('funds')} className={cur == 'funds' ? 'curr' : ''} >
                                请款预计跟踪表
                            </a>
                        </div>
                        { cur === 'co' && <CoFollowTable /> }
                        { cur === 'funds' && <FundsFollowTable /> }
                    </div>
                </div>
                
            </div>
        );
    }
}

export default CoFollowFunds;


// WEBPACK FOOTER //
// ./src/components/contractManagement/coFollowFunds/index.js